<div class="tw-mb-1" *ngIf="showRegionSelector">
  <bit-menu #environmentOptions>
    <a
      *ngFor="let region of availableRegions$ | async"
      bitMenuItem
      [attr.href]="
        region == currentRegion ? 'javascript:void(0)' : region.urls.webVault + routeAndParams
      "
    >
      <bit-icon
        name="bwi-check"
        class="bwi-fw bwi-sm"
        [style.visibility]="region == currentRegion ? 'visible' : 'hidden'"
      ></bit-icon>
      {{ region.domain }}
    </a>
  </bit-menu>
  <div class="tw-text-xs tw-text-fg-body-subtle">
    {{ "accessing" | i18n }}
    <a
      [routerLink]="[]"
      [bitMenuTriggerFor]="environmentOptions"
      class="tw-inline-flex tw-items-center tw-gap-1 tw-no-underline tw-px-1.5 tw-py-0.5 tw-rounded-md tw-font-medium tw-text-fg-heading hover:tw-bg-[var(--vk-hover)]"
    >
      <span>{{ currentRegion?.domain }}</span>
      <bit-icon name="bwi-angle-down" class="bwi-fw bwi-sm tw-text-fg-body-subtle"></bit-icon>
    </a>
  </div>
</div>
